import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormBuilder } from '@angular/forms';
import { HttpService } from '../shared/services/http.service';


const SINGLE_SCHOOL = 'Single School';
const SCHOOL_GROUP = 'School Group';
const CORPORATE = 'Corporate';

@Component({
    selector: 'app-share-user-guides',
    templateUrl: './share-user-guides.component.html',
    styleUrls: ['./share-user-guides.component.scss'],
    standalone: false
})
export class ShareUserGuidesComponent implements OnInit {


  @Input() clientKind;

  @Input() clientId;

  form = new UntypedFormGroup({
    emails: new UntypedFormControl('', Validators.required),
    type: new UntypedFormControl('', Validators.required)
  });


  options = []

  sendgridTemplateMap = {
    [SINGLE_SCHOOL]: 'd-85889a7d6e094cd0a4d9815285f673a3',
    [SCHOOL_GROUP]: 'd-b8ec54bbc0fb447590bb7c7841d66f64',
    [CORPORATE]: 'd-f33d362d2df14db0bb777c505e2aa08a'
  }

  @Output() close: EventEmitter<Boolean> = new EventEmitter<Boolean>();

  constructor(private fb: UntypedFormBuilder, private httpService: HttpService) { }

  changeType(e) {
    this.type.setValue(e.target.value, {
      onlySelf: true
    })
  }

  get type() {
    return this.form.get('type');
  }


  ngOnInit() {

    if( this.clientKind == 'EDUCATION' ){
      this.options = [SINGLE_SCHOOL,SCHOOL_GROUP]
    }else{
      this.options = [CORPORATE]
    }

    this.createForm()
    this.rebuildForm()
  }

  createForm(){
    this.form = this.fb.group({
      emails: ['', Validators.required],
      type: ['', Validators.required]
    })
  }

  rebuildForm(){
    this.form.reset({
      emails: '',
      type: ''
    })
  }

  async onSubmit() {
    if (this.form.valid) {
      console.log(this.form.value, this.sendgridTemplateMap[this.form.value.type]);

      const res:any = await this.httpService.postAsync('guide/emailPdfs', {
        emails: this.form.value.emails,
        sendgridTemplateId: this.sendgridTemplateMap[this.form.value.type],
        clientId: this.clientId
      })

      if( res.success ){
        alert("Success")
      }else{
        alert("There was an error emailing the guides.")
      }

      // Handle form submission logic here
      this.close.emit()

    }
  }

  onCancel(){
    this.close.emit()
  }
}
